import { createAction } from '@reduxjs/toolkit';
export const setViewOffset = createAction('setViewOffset');
export const seedView = createAction('seedView');
export const resetView = createAction('resetView');
export const deleteView = createAction('deleteView');
export const setViewColumns = createAction('setViewColumns');
export const updateTempViewCrmSearchQuery = createAction('updateTempViewCrmSearchQuery');
export const resetTempViewFilters = createAction('resetTempViewFilters');
export const setSortState = createAction('setSortState');
export const setSearchText = createAction('setSearchText');